// extracted by mini-css-extract-plugin
export default {"tribal__intro":"Info_tribal__intro__q+3BZ","tribal__image":"Info_tribal__image__9pkJP"};